export default {
  empty: 'No results',
  showPreviousText: 'Show previous results',
  showMoreText: 'Show more results',
  item: function item(data) {
    return JSON.stringify(data, null, 2);
  }
};


// WEBPACK FOOTER //
// ../node_modules/instantsearch.js/es/widgets/infinite-hits/defaultTemplates.js